import { ProgressSpinner, TablePagination } from '@repo/atomic-components';
import { UploadedDocumentsTable } from './components';
import { useUploadDocumentsTable } from './hooks';
import { CASE_DOCUMENT_DELETE_CONFIRM } from '@/constants';
import { ProviderSelectorPopup } from '@/ui/pages/MedicalRecordsPage/components';
import { WarningConfirmationDialog } from '@/ui/components/WarningConfirmationDialog';
import { PaginatorInfoDialog } from '@/ui/components/PaginatorInfoDialog';

export const UploadedMedicalRecords = () => {
  const {
    table,
    isTableDataLoading,
    providerSelectorVisible,
    setProviderSelectorVisible,
    providerSelectorPosition,
    caseProvidersList,
    handleProviderSelect,
  } = useUploadDocumentsTable();

  return (
    <>
      {/* CaseTemplate's page header sits at z-[1102]; PrimeReact's
          default modal mask lands at z-[1101] so the nav would
          otherwise stay un-dimmed while the dialog itself dims
          everything below it. Bumping the mask to z-[1200] makes
          the whole viewport dim uniformly. */}
      <PaginatorInfoDialog />
      <WarningConfirmationDialog
        id={CASE_DOCUMENT_DELETE_CONFIRM}
        bodyText="The selected document will be permanently deleted."
        confirmLabel="Delete"
        pt={{ mask: { className: '!z-[1200]' } }}
      />

      {providerSelectorVisible && (
        <ProviderSelectorPopup
          caseProvidersList={caseProvidersList}
          onSelect={handleProviderSelect}
          onClose={() => setProviderSelectorVisible(false)}
          position={providerSelectorPosition}
        />
      )}

      <div className="flex h-full w-full flex-col gap-2 overflow-hidden">
        <div className="relative h-full w-full overflow-hidden">
          {/* Bordered table card with internal vertical scroll —
              mirrors the wrapper on MedicalRecordsPage so the case
              page's upload table reads as the same component. */}
          <div className="bg-fletchers-white border-fletchers-gray-110 h-full w-full overflow-x-hidden overflow-y-auto rounded-lg border px-2">
            <UploadedDocumentsTable table={table} />
          </div>

          {isTableDataLoading && (
            <div className="pointer-events-none absolute top-0 left-0 flex h-full w-full items-center justify-center">
              <ProgressSpinner style={{ width: '100px', height: '100px' }} strokeWidth="4" animationDuration="1.5s" />
            </div>
          )}
        </div>

        <div className="mt-auto flex justify-center">
          <TablePagination table={table} />
        </div>
      </div>
    </>
  );
};
